function formatearFechaCorta(fecha) {
    const date = new Date(fecha);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
}

function formatearHoraCorta(fecha) {
    if (!fecha) return '—';
    const date = new Date(fecha);
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${hh}:${min}`;
}

function getPunishment(t) {
    if (t.forgiven) return 0;
    if (t.progressPunishment > 0) return t.progressPunishment;
    if (t.globalCostPunishment > 0) return t.globalCostPunishment;
    if (t.difference > 0) return t.punishment;
    return 0;
}

// ─── TOGGLE: cambia a true para mostrar la columna EXC ───────────────────────
const SHOW_EXC_COLUMN = false;
// ─────────────────────────────────────────────────────────────────────────────

const ReceiptPrintViewThermal = ({ data }) => (
    <html>
        <head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Recibo Térmico</title>
            <style>{`
                * { box-sizing: border-box; margin: 0; padding: 0; }

                body {
                    font-family: Arial, sans-serif;
                    font-size: 16px;
                    color: #000;
                    background: #fff;
                    width: 72mm;
                    margin: 0 auto;
                    padding: 4px 4px 16px 4px;
                }

                .doc-header {
                    text-align: center;
                    font-size: 13px;
                    font-weight: bold;
                    border-bottom: 1px dashed #ffffff;
                    padding-bottom: 4px;
                    margin-bottom: 6px;
                    text-transform: uppercase;
                }

                .doc-meta {
                    font-size: 10px;
                    margin-bottom: 8px;
                    text-align: center;
                }

                .salida-block { margin-bottom: 10px; }

                .salida-header {
                    font-weight: bold;
                    font-size: 11px;
                    text-transform: uppercase;
                    border-top: 1px dashed #ffffff;
                    padding-top: 4px;
                    margin-bottom: 2px;
                }

                .salida-date { font-size: 10px; margin-bottom: 4px; }

                table { width: 100%; border-collapse: collapse; margin-bottom: 4px; }

                th {
                    font-size: 9px;
                    font-weight: bold;
                    text-transform: uppercase;
                    border-bottom: 1px solid #ffffff;
                    padding: 1px 2px;
                    text-align: left;
                }

                td { font-size: 10px; padding: 1px 2px; vertical-align: top; }

                .salida-total {
                    font-weight: bold;
                    font-size: 11px;
                    text-align: right;
                    border-top: 1px solid #ffffff;
                    padding-top: 2px;
                    margin-bottom: 4px;
                }

                .excusa-item { font-size: 10px; margin-bottom: 2px; padding-left: 4px; }

                .nota-item {
                    font-size: 10px;
                    margin-bottom: 2px;
                    padding-left: 4px;
                    font-style: italic;
                }

                .omitidas-block {
                    border-top: 1px dashed #ffffff;
                    margin-top: 6px;
                    padding-top: 4px;
                    font-size: 10px;
                }

                .omitidas-title { font-weight: bold; margin-bottom: 2px; font-size: 10px; }
                .omitida-item { margin-bottom: 2px; padding-left: 4px; }

                .extra-block {
                    border-top: 1px dashed #ffffff;
                    margin-top: 6px;
                    padding-top: 4px;
                    font-size: 10px;
                }

                .extra-title { font-weight: bold; margin-bottom: 2px; }

                .extra-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 1px;
                }

                .global-total {
                    border-top: 2px solid #ffffff;
                    margin-top: 8px;
                    padding-top: 6px;
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                @media print {
                    @page {
                        margin: 6mm;
                    }
                    body {
                        font-size: 14px;  /* mucho más grande de lo que parece necesario */
                        width: 100%;
                    }
                    th { font-size: 12px; }
                    td { font-size: 14px; }
                    .doc-header { font-size: 16px; }
                    .global-total { font-size: 18px; }
                }
            `}</style>
        </head>
        <body>
            <div className="doc-header">Recibo de Cobro</div>
            <div className="doc-meta">
                {data.routeName && <div>{data.routeName}</div>}
                <div>Generado: {formatearFechaCorta(data.date)}</div>
                {data.commitId && <div>Recibo #{data.commitId}</div>}
            </div>

            {data.salidas.map((s) => {
                const excusedTickets = s.tickets.filter(
                    (t) => t.forgiven && t.excuse && t.excuse.trim() !== ''
                );
                const computedNotes = s.computedNotes || [];

                const wGeo = SHOW_EXC_COLUMN ? '28%' : '38%';
                const wProg = SHOW_EXC_COLUMN ? '16%' : '18%';
                const wReal = SHOW_EXC_COLUMN ? '16%' : '18%';
                const wImp = SHOW_EXC_COLUMN ? '20%' : '26%';
                const wExc = '20%';

                return (
                    <div className="salida-block" key={s.id}>
                        <div className="salida-header">
                            {s.tickets[0]?.device || `Salida #${s.id}`}
                        </div>
                        <div className="salida-date">
                            Salida {formatearFechaCorta(s.date)}
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: wGeo }}>GEO</th>
                                    <th style={{ width: wProg }}>PROG</th>
                                    <th style={{ width: wReal }}>REAL</th>
                                    <th style={{ width: wImp }}>IMPORTE</th>
                                    {SHOW_EXC_COLUMN && <th style={{ width: wExc }}>EXC</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {s.tickets.map((t, idx) => {
                                    const punishment = getPunishment(t);
                                    const excLabel = t.forgiven ? `EX${idx + 1}` : '';
                                    return (
                                        <tr key={t.id}>
                                            <td style={{ width: wGeo }}>{t.geofence}</td>
                                            <td style={{ width: wProg }}>{formatearHoraCorta(t.expectedTime)}</td>
                                            <td style={{ width: wReal }}>{formatearHoraCorta(t.enterTime)}</td>
                                            <td style={{ width: wImp }}>${punishment.toFixed(2)}</td>
                                            {SHOW_EXC_COLUMN && <td style={{ width: wExc }}>{excLabel}</td>}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <div className="salida-total">
                            IMPORTE TOTAL: ${s.total.toFixed(2)}
                        </div>

                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '4px' }}>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: '9px', padding: '1px 2px', textAlign: 'left' }}></th>
                                    <th style={{ fontSize: '9px', padding: '1px 2px', textAlign: 'center' }}>SUB</th>
                                    <th style={{ fontSize: '9px', padding: '1px 2px', textAlign: 'center' }}>BAJ</th>
                                    <th style={{ fontSize: '9px', padding: '1px 2px', textAlign: 'center' }}>UNIT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    { label: 'P1', inn: s.counter1In ?? 0, out: s.counter1Out ?? 0 },
                                    { label: 'P2', inn: s.counter2In ?? 0, out: s.counter2Out ?? 0 },
                                    {
                                        label: 'TOT',
                                        inn: (s.counter1In ?? 0) + (s.counter2In ?? 0),
                                        out: (s.counter1Out ?? 0) + (s.counter2Out ?? 0),
                                        isTotal: true,
                                    },
                                ].map(({ label, inn, out, isTotal }) => (
                                    <tr key={label} style={isTotal ? { fontWeight: 'bold', borderTop: '1px solid #000' } : {}}>
                                        <td style={{ fontSize: '10px', padding: '1px 2px' }}>{label}</td>
                                        <td style={{ fontSize: '10px', padding: '1px 2px', textAlign: 'center' }}>{inn}</td>
                                        <td style={{ fontSize: '10px', padding: '1px 2px', textAlign: 'center' }}>{out}</td>
                                        <td style={{ fontSize: '10px', padding: '1px 2px', textAlign: 'center' }}>{inn - out}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {computedNotes.length > 0 && (
                            <div>
                                {computedNotes.map((note, idx) => (
                                    <div className="nota-item" key={idx}>* {note}</div>
                                ))}
                            </div>
                        )}

                        {excusedTickets.length > 0 && (
                            <div>
                                {excusedTickets.map((t) => (
                                    <div className="excusa-item" key={t.id}>
                                        {t.geofence} EXCUSA POR: {t.excuse}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}

            {data.extraCharges?.length > 0 && (
                <div className="extra-block">
                    <div className="extra-title">Cargos adicionales:</div>
                    {data.extraCharges.map((c, idx) => (
                        <div className="extra-row" key={idx}>
                            <span>{c.description}</span>
                            <span>${Number(c.amount).toFixed(2)}</span>
                        </div>
                    ))}
                    <div className="extra-row" style={{ fontWeight: 'bold', borderTop: '1px solid #000', marginTop: '2px', paddingTop: '2px' }}>
                        <span>Subtotal cargos:</span>
                        <span>${data.extraChargesTotal.toFixed(2)}</span>
                    </div>
                </div>
            )}

            {data.omittedSalidas?.length > 0 && (
                <div className="omitidas-block">
                    <div className="omitidas-title">Salidas omitidas:</div>
                    {data.omittedSalidas.map((o) => (
                        <div className="omitida-item" key={o.id}>
                            {formatearFechaCorta(o.date)}{o.reason ? ` — ${o.reason}` : ''}
                        </div>
                    ))}
                </div>
            )}

            <div className="global-total">
                Total: ${data.globalTotal.toFixed(2)}
            </div>
        </body>
    </html>
);

export default ReceiptPrintViewThermal;